module.exports = __webpack_public_path__ + "static/media/evolution_68.8531aa8a.svg";